import { TOKEN_BLACKLIST } from 'config/constants/info'
import { gql } from 'graphql-request'
import { useEffect, useState } from 'react'
import { infoClientWithChain } from 'utils/graphql'
import { getDeltaTimestamps } from 'utils/getDeltaTimestamps'

interface TopPoolsResponse {
  pairDayDatas: {
    id: string
  }[]
}

/**
 * Initial pools to display on the home page
 */
const fetchTopPools = async (chainId: number, protocol: string, timestamp24hAgo: number): Promise<string[]> => {
  try {
    const query = gql`
      query topPools($blacklist: [String!], $timestamp24hAgo: Int) {
        pairDayDatas(
          first: 30
          where: { ${protocol === 'stable' ? '' : 'dailyTxns_gt: 300'}, token0_not_in: $blacklist, token1_not_in: $blacklist, date_gt: $timestamp24hAgo }
          orderBy: dailyVolumeUSD
          orderDirection: desc
        ) {
          id
        }
      }
    `
    const data = await infoClientWithChain(chainId, protocol).request<TopPoolsResponse>(query, { blacklist: TOKEN_BLACKLIST, timestamp24hAgo })
    // pairDayDatas id has compound id "0xPOOLADDRESS-NUMBERS", extracting pool address with .split('-')
    return data?.pairDayDatas.map((p) => p.id.split('-')[0])
  } catch (error) {
    console.error('Failed to fetch top pools', error)
    return []
  }
}

/**
 * Fetch top addresses by volume
 */
const useTopPoolAddresses = (chainId: number, protocol: string): string[] => {
  const [topPoolAddresses, setTopPoolAddresses] = useState<string[]>([])
  const [timestamp24hAgo] = getDeltaTimestamps()

  useEffect(() => {
    const fetch = async () => {
      const addresses = await fetchTopPools(chainId, protocol, timestamp24hAgo)
      if (addresses && addresses.length > 0) {
        setTopPoolAddresses(addresses)
      }
    }
    if (topPoolAddresses.length === 0) {
      fetch()
    }
  }, [chainId, topPoolAddresses, timestamp24hAgo, protocol])

  return topPoolAddresses
}

export const fetchTopPoolAddresses = async (chainId: number, protocol: string) => {
  const [timestamp24hAgo] = getDeltaTimestamps()

  const addresses = await fetchTopPools(chainId, protocol, timestamp24hAgo)
  return addresses
}

export default useTopPoolAddresses
